<template>
  <router-link
    to="/teaser"
    class="teaser-banner"
  >
    <div class="teaser-banner__live">
      {{ $content.teaser.live }}
    </div>
    <div class="teaser-banner__title">
      {{ $content.teaser.title }}
    </div>
    <div
      class="teaser-banner__cta"
    >
      <button class="yellow-button">
        {{ $content.teaser.cta }}
        <div class="arrow decors-icons-teaser-arrow" />
      </button>
    </div>
    <div class="teaser-banner__image decors-background-teaser-personnage" />
  </router-link>
</template>
<script>

export default {
  name: 'TeaserBanner',
  components: {
  },
};
</script>
<style lang="stylus" scoped>
.teaser-banner {
  display: block;
  max-width: $content-width;
  margin: 80px auto 0;
  padding: 0;
  background-color: $cl-dark-blue;
  position: relative;
  cursor: pointer;

  +mobile() {
    margin: 140px auto 0;
  }

  &:hover {
    .arrow {
      transform: translateX(5px);
    }

    .yellow-button {
      background-color: $cl-dark-yellow;
    }

    .teaser-banner__live {
      transform: translateY(-110%);
    }

    .teaser-banner__image {
      transform: translateX(-20px);
      +mobile() {
        transform: translateY(-100%) translateX(-20px);
      }
    }
  }

  &__live {
    position: absolute;
    top: 7px;
    left: 2px;
    border-radius: 50%;
    padding: 10px 12px 10px 10px;
    border-radius: 24px;
    border-bottom: 2px solid var(--yellow, #F0CC31);
    background: white;
    color: var(--dark-blue, #201547);
    font-size: 16px;
    letter-spacing: 1.92px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;

    +mobile(){
      left: 5px;
      top: 10px
    }

    &::before {
      display: block;
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $cl-red;
      animation: blink 1s infinite;
    }

    @keyframes blink {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  &__title {
    background-color: $cl-light-blue;
    width: fit-content;
    font-size: 23px;
    text-transform: uppercase;
    letter-spacing: 2.76px;
    padding: 12px
    text-align: left;
  }

  &__cta {
    display: block;
    border-top: 2px solid $cl-yellow;

    .yellow-button {
      background-color: $cl-yellow;
      border: none;
      padding: 10px 20px;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      color: $cl-dark-blue;
      font-size: 23px;
      font-weight: 700;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 30px;
      transition: background-color 0.3s ease-in-out

      .arrow {
        transition: transform 0.3s ease-in-out;
      }

      &:hover {
        background-color: $cl-dark-yellow;
        .arrow {
          transform: translateX(5px);
        }
      }
    }
  }

  &__image {
    position: absolute;
    bottom: 0;
    right: 20px;
    transition: transform 0.3s ease-in-out;

    +mobile() {
      bottom: auto;
      top: 0;
      transform: translateY(-100%);
    }
  }
}
</style>
